// imports
import _get from 'lodash/get';
import _map from 'lodash/map';

import Config from '$root/Config';
import BinMarkerModel from '$models/bin/BinMarkerModel';
import binDrupalFilterParent from '$models/bin/binDrupalFilterParent';
import MMCollection from './MMCollection';

const filterDictionary = {
	material: 'field_bin_material',
	location_type: 'field_bin_location_type',
	custom_id: 'field_bin_g_id',
	latitude: 'field_bin_latitude',
	longitude: 'field_bin_longitude',
	last_measurement: 'field_bin_last_measurement_date',
	first_measurement: 'field_bin_first_measurement_date',

	bin_active: 'field_bin_status',
	bin_lid_size: 'field_bin_lid_size',
	color: 'field_bin_color',
	bin_material: 'field_bin_material',
	bin_post_code: 'field_bin_post_code',
	bin_surface: 'field_bin_surface',
	bin_volume: 'field_bin_volume',
	bin_damage: 'field_bin_damage',
	bin_emptying_frequency: 'field_bin_emptying_frequency',
	remark: 'field_bin_remark',

	cigarettes: 'field_measurement_cigarettes',
	addition: 'field_measurement_addition.id',
	fill_degree: 'field_measurement_fill_degree',
	illegal_dump: 'field_measurement_illegal_dump',
};

// class definition
export default class BinMarkerSmallCollection extends MMCollection {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.Model = args.Model || BinMarkerModel;
		args.parentModel = binDrupalFilterParent();
		args.filterDictionary = filterDictionary;
		args.useProQueryParams = true;
		// call super constructor
		super(args);
	}

	parse(data) {
		const markers = _get(data, 'features');
		data = _map(markers, (item) => {
			const properties = _get(item, 'properties') || {};
			const binType = properties.field_bin_type || properties.type || properties.binType || '';
			const gId = properties.field_bin_g_id || properties.customBinId || properties.binId || properties.gId || '';
			const coordinates = {
				lat: parseFloat(_get(item, 'geometry.coordinates.1', _get(item, 'geometry.coordinates[1]'))),
				lng: parseFloat(_get(item, 'geometry.coordinates.0', _get(item, 'geometry.coordinates[0]'))),
			};

			// Prefer nested Pro type.uuid; do not treat type name strings as UUIDs (backend should return uuid)
			const typeUuid = _get(properties, 'type.uuid')
				|| _get(properties, 'type.id')
				|| properties.binTypeUuid
				|| properties.field_bin_type_uuid
				|| '';
			const typeParentUuid = _get(properties, 'type.parent.uuid')
				|| _get(properties, 'type.parent.id')
				|| properties.binTypeParentUuid
				|| properties.field_bin_type_parent_uuid
				|| '';
			const typeName = typeof binType === 'string' ? binType : (_get(binType, 'name') || '');

			const preparedItem = {
				...properties,
				id: properties.uuid || properties.id || _get(item, 'id'),
				uuid: properties.uuid || properties.id || _get(item, 'id'),
				coordinates,
				parentModel: {},
				binType: typeName,
				gId,
				title: properties.title || '',
				active: properties.status !== undefined ? Boolean(properties.status) : Boolean(Number(properties.field_bin_status)),
				field_bin_g_id: gId,
				field_bin_type: typeName,
				field_bin_type_uuid: typeUuid,
				field_bin_type_parent_uuid: typeParentUuid,
				field_bin_status: properties.status === false || properties.status === 0 || properties.field_bin_status === '0' ? '0' : '1',
				field_bin_post_code: properties.postalCode || properties.field_bin_post_code || '',
				field_bin_street: properties.street || properties.field_bin_street || '',
				field_bin_volume: properties.volume != null ? String(properties.volume) : (properties.field_bin_volume || ''),
				field_bin_color: properties.color || properties.field_bin_color || '',
				field_bin_material: properties.material || properties.field_bin_material || '',
				field_bin_surface: properties.surface || properties.field_bin_surface || '',
				field_bin_lid_size: properties.lidSize != null ? String(properties.lidSize) : (properties.field_bin_lid_size || ''),
				field_bin_emptying_frequency: properties.emptyingFrequency || properties.field_bin_emptying_frequency || '',
				field_bin_damage: properties.damageAmount || properties.field_bin_damage || '',
				field_bin_remark: properties.remark || properties.field_bin_remark || '',
				field_bin_location: properties.locationType || properties.field_bin_location || '',
			};
			// create model
			const newModel = new this.Model().set(preparedItem);
			return newModel;
		});

		return super.parse(data);
	}

	fetch() {
		this.setConfig('url', Config.getUrl('binsGeoJson'));
		this.setConfig('params', { format: 'geojson' });
		return super.fetch();
	}
}
